/**
 * Ghosty's central console (One Console P5). The default `ghosty login` flow
 * — and `--company <slug>` — opens {CONSOLE_URL}/cli/login; the console picks
 * or resolves the target stamp server-side and hands the browser off to that
 * stamp's own /cli/authorize, which issues the stamp JWT straight to the
 * CLI's loopback. This replaced the old control-tower discovery call
 * (GET ct.getghosty.dev/api/tenants/{slug}/discovery — never shipped).
 * Override for local dev with GHOSTY_CONSOLE_URL.
 */
export const CONSOLE_URL = process.env.GHOSTY_CONSOLE_URL ?? 'https://getghosty.dev';

/** Fallback product name when no profile/branding is cached. */
export const DEFAULT_PRODUCT_NAME = 'Ghosty';

/** Slug rules — must match admin-app's SLUG_PATTERN (blocks/types.ts). */
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

/** GitHub handle — must match admin-app's GITHUB_USERNAME_PATTERN. */
export const GITHUB_USERNAME_PATTERN = /^[a-zA-Z0-9-]{1,39}$/;

/** Loopback login flow timeout. */
export const LOGIN_TIMEOUT_MS = 10 * 60 * 1000;

/** Provision polling. */
export const PROVISION_POLL_INTERVAL_MS = 5000;

/**
 * Exit codes: 0 ok, 1 generic failure, 2 reserved (usage errors), 3 = the
 * server refused this CLI version (426 + cli_outdated) — agents should
 * update the CLI and retry.
 */
export const EXIT_CLI_OUTDATED = 3;

/** Manifest file caps (server enforces 512KB per file too). */
export const MANIFEST_FILE_CAP_BYTES = 512 * 1024;
export const MANIFEST_TOTAL_CAP_BYTES = 5 * 1024 * 1024;
